import { DomainsService } from '@/core/services/api-gateway'
import { TAddDomainTag } from '@/ui/drawer/digitalFootprint/addDomain/useAddDomain'
import { DomainParameters } from '@atbay/domains-manager-node-sdk'
import { BaseModule } from '@core/base/module/base-module'
import { IDomainsState, TDomain } from './domains'

const state = {
    domains: [],
    loading: false,
    error: '',
} satisfies IDomainsState

class Domains extends BaseModule<IDomainsState> {
    constructor(state: IDomainsState) {
        super(state, 'domains.module')
    }

    async getAccountDomains() {
        const result = await DomainsService.getAccountDomains()

        if (result) {
            this.store.setKey('domains', result as TDomain[])
        } else {
            this.store.setKey('domains', [])
        }
    }

    public getAcceptedDomainsWithSubscription() {
        return this.filterAcceptedDomains(this.useStore().domains)
    }

    get acceptedDomains() {
        return this.filterAcceptedDomains(this.store.get().domains)
    }

    private filterAcceptedDomains(domains: TDomain[]) {
        return domains
            .filter(({ status }) => status !== 'Discovered')
            .sort((a, b) => a.status.localeCompare(b.status))
    }

    get discoveryScanDomains() {
        return this.store
            .get()
            .domains.filter((domain) => domain.status === 'Discovered')
    }

    public updateDeletedDomainsAsInProcess(ids: string[]) {
        const domains = this.store.get().domains
        domains.forEach((item) => {
            item.inProcess = ids.includes(item.id)
        })
        this.store.setKey('domains', [...domains])
    }

    async checkDomainValidity(domain: string) {
        this.store.setKey('error', '')
        this.store.setKey('loading', true)
        const [error, isDomainValid] =
            await DomainsService.validateDomain(domain)
        this.store.setKey('loading', false)
        this.store.setKey('error', error || '')
        return {
            isValid: isDomainValid,
            errorMessage: error,
        }
    }

    async submitDomains(rawDomains: TAddDomainTag[]) {
        this.store.setKey('loading', true)
        const domains = rawDomains.map(({ id, value, status }) => {
            if (id === value) {
                return { domain: value, status } as DomainParameters
            }
            return { id, domain: value, status } as DomainParameters
        })
        const result = await DomainsService.addDomains(domains)
        this.store.setKey('loading', false)

        return { valid: result }
    }
}

export const DomainsModule = new Domains(state)
